import MySharedFileWidget from '../../FileShareOoi/Widget';

export default MySharedFileWidget;
